import { FC } from "react";
import { Box, BoxProps } from "@mui/material";

interface CubeProps {
  color?: string;
  border?: string;
  radius?: number;
  width?: number;
  height?: number | string;
  dashed?: boolean;
  onClick?(): void;
  sx?: BoxProps["sx"];
}

export const Cube: FC<CubeProps> = ({
  sx,
  color,
  border,
  radius = 0.5,
  width = 8,
  height = 8,
  onClick,
  dashed = false,
}) => {
  return (
    <Box
      component="span"
      mr={0.5}
      width={width}
      height={height}
      onClick={onClick}
      bgcolor={dashed ? "transparent" : color}
      display="inline-block"
      borderRadius={dashed ? 0 : radius}
      border={border}
      sx={{
        flexShrink: 0,
        ...(dashed && {
          backgroundImage: `repeating-linear-gradient(90deg, ${color}, ${color} 2px, transparent 2px, transparent 4px)`,
        }),
        ...sx,
      }}
    />
  );
};
